// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#groups-eva{padding:0 15px 0 40px}#groups-eva .title-eva{text-align:left;font-family:\"GothamSSm-Medium\",Arial,sans-serif;font-size:20px;font-weight:500;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#4a4a4a;margin:0;padding-top:20px;margin-bottom:90px}#groups-eva .button-eva-container{padding-top:0 !important}#groups-eva .button-eva-container button{padding:7px}\n", ""]);
// Exports
module.exports = exports;
